
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class VPageHeader extends Vue {
    @Prop({ type: String, default: '' })
    public title!: string;

    @Prop({ type: Boolean, default: false })
    public noMargin!: boolean;
}
